export default __webpack_public_path__ + "static/media/2nd_Floor_Plan.f4659181.jpg";